/**
 * <StudentSettings />
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import PanelWrapper from 'components/UI/PanelWrapper';
import { browserHistory, Link } from 'react-router';
import Panel from 'components/UI/Panel';

import Form from 'components/Form';
import CustomField from 'components/UI/CustomField'
import getStudentCustomFields from 'controllers/student/getStudentCustomFields';
import updateStudentCustomFields from 'controllers/student/updateStudentCustomFields';
import BasicInfo from './BasicInfo';
import locale from './locale';
import './StudentSettings.scss';

class StudentSettings extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.state = {
      fetchingCustomField: false,
      setting: {}
    }
  }

  componentWillMount() {
    this.fetchSetting();
  }

  fetchSetting() {
    const schoolId = localStorage.getItem('schoolId');
    getStudentCustomFields(schoolId)
    .then((res)=>{
      let setting;
      if (res.student_fields_setting && res.student_fields_setting.fields) {
        setting = { ...res.student_fields_setting }
      } else {
        setting = {
          fields: [],
        }
      }
      this.setState({
        setting,
        fetchingCustomField: false,
      });
    })
  }

  updateSetting() {
    const schoolId = localStorage.getItem('schoolId');
    const toServer = this.state.setting;

    updateStudentCustomFields(schoolId, toServer)
      .then((res)=>{
    });

  }
  onChange(opts) {
    
    let newFields = this.state.setting.fields;

    const {
      index,
      fieldValue
    }= opts;

    newFields[index] = {
      ...newFields[index],
      ...fieldValue,
    }

    this.setState({
      setting: {
        ...this.state.setting,
        fields: newFields,
      }
    });
  }

  updateField(newFields) {
    this.setState({
      setting: {
        ...this.state.setting,
        fields: newFields,
      }
    },()=>{
      this.updateSetting();
    });
  }
  render() {
    const { setting, fetchingCustomField } = this.state
    const { fields } = setting    
    return (
      <PanelWrapper>

        <div className='student-settings'>
          <div className='bread-crumbs'>
            <Link to='/student'>{__('Student', locale)}</Link>
            <span> / </span>
            <span>{__('Input Fields Setting', locale)}</span>
            <Link className='registration-table-close pull-right' to={'/student'}>
          <i className='fa icon-cancel'></i>
				  </Link>

          </div>
          <div className='row'>
            <div className='col-sm-6'>
              <BasicInfo />
            </div>
            <div className='col-sm-6'>
              <CustomField 
                fields={fields}
                closeEditorsWhenAddNewItem={true}
                isSortable={true} //if it is able to drag and drop
                fetching={fetchingCustomField}
                onChange={(opts)=>this.onChange(opts)}
                updateField={(newFields)=>this.updateField(newFields)}
                saveField={()=>this.updateSetting()}
              />
            </div>
          </div>
        </div>
      </PanelWrapper>
    )
  }
}

export default StudentSettings;



// WEBPACK FOOTER //
// ./src/containers/pages/StudentSettings/index.js